import { usePaneLocation } from "@/hooks/pane-routing";

/** File record id from the open right-pane file-record route, or null. Files
 *  open in the right pane (see useOpenFileRecord), so a main-route match never
 *  fires — read the pane location instead, the same way useActiveSkillId does. */
export function useActiveFileRecordId(): string | null {
  const paneLocation = usePaneLocation("rightPane");
  const match = paneLocation?.pathname?.match(/^\/file-record\/([^/]+)/);
  return match?.[1] ?? null;
}
